import React from 'react'
import PropTypes from 'prop-types'

// Figma "Rotate phone icon" (node 17955:117113): tilted phone between two
// rotation arcs, rebuilt from the exported vectors. Inherits currentColor so
// the toolbar button and the coach mark can tint it differently.
const RotatePhoneIcon = ({size = 20}) => (
  <svg width={size} height={size} viewBox="2.7 2.7 21.9 21.9" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g transform="rotate(-45 13.65 13.65)">
      <g transform="translate(3.35 4.65)">
        <g transform="translate(0 17.995) scale(1 -1)">
          <g transform="translate(-1 3.87)">
            <path
              d="M20.5953 1.00021C21.2344 2.23645 21.5953 3.63978 21.5953 5.12741C21.5953 6.5032 21.2866 7.80689 20.7347 8.97299C20.693 9.06111 20.5653 9.03994 20.5518 8.94339L20.2977 7.12765"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path
              d="M2 9.2546C1.36093 8.01836 1 6.61503 1 5.1274C1 3.75161 1.3087 2.44792 1.86061 1.28182C1.90232 1.1937 2.03004 1.21487 2.04355 1.31143L2.29766 3.12716"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </g>
        </g>
        <g transform="translate(3.3 -1)">
          <rect x="1" y="1" width="12" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M6 16H8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        </g>
      </g>
    </g>
  </svg>
)

RotatePhoneIcon.propTypes = {
  size: PropTypes.number,
}

export default RotatePhoneIcon
